// 메트로놈 정지 시 "연습 일지에 저장할까요?" (연동 방식이 '물어보기'일 때)
import React, { useEffect, useState } from 'react';
import { Box, Button, Chip, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import Dialog from '../components/AppDialog';
import { formatDuration } from './MetronomeProvider';

export default function SessionSaveDialog({ session, pieces, onClose, onSave }) {
  const [pieceId, setPieceId] = useState(0);

  useEffect(() => {
    if (session) setPieceId(session.pieceId || 0);
  }, [session]);

  return (
    <Dialog open={!!session} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700, pb: 0.5 }}>
        {session && `${formatDuration(session.seconds)} 연습했어요`}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          ♩ = {session?.bpm} · 어떤 곡을 연습했는지 고르면 곡별로 기록돼요.
        </Typography>
        <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap' }}>
          <Chip
            label="곡 지정 없음"
            onClick={() => setPieceId(0)}
            color={pieceId === 0 ? 'primary' : 'default'}
            variant={pieceId === 0 ? 'filled' : 'outlined'}
          />
          {pieces.map((p) => (
            <Chip
              key={p.id}
              label={p.title}
              onClick={() => setPieceId(p.id)}
              color={pieceId === p.id ? 'primary' : 'default'}
              variant={pieceId === p.id ? 'filled' : 'outlined'}
            />
          ))}
        </Box>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
          묻지 않고 저장하거나 연동을 끄려면 메트로놈 설정의 "연습 일지 연동"을 바꿔 주세요.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">저장 안 함</Button>
        <Button variant="contained" onClick={() => onSave({ ...session, pieceId })}>일지에 저장</Button>
      </DialogActions>
    </Dialog>
  );
}
